import {
  UPLOAD_DOCUMENT_MIME_TYPES,
  UPLOAD_IMAGE_MIME_TYPES,
  UPLOAD_VIDEO_MIME_TYPES,
} from 'screens/Finder/components/views/GalleryView/constants'

export const MEDIA_LIBRARY_MIME_TYPES = [...UPLOAD_IMAGE_MIME_TYPES, ...UPLOAD_VIDEO_MIME_TYPES]

export const SOURCE_MATERIAL_MIME_TYPES = [...UPLOAD_DOCUMENT_MIME_TYPES]

export const ACCEPTED_BRAND_MATERIALS_MIME_TYPES = [...MEDIA_LIBRARY_MIME_TYPES, ...SOURCE_MATERIAL_MIME_TYPES].join(
  ',',
)

export type UploadDestination = 'mediaLibrary' | 'sourceMaterials'

export const destinationForFile = (file: File): UploadDestination => {
  const mime = file.type ?? ''
  if (mime.startsWith('image/') || mime.startsWith('video/')) return 'mediaLibrary'
  return 'sourceMaterials'
}

export const splitFilesByDestination = (files: File[]) => {
  const mediaLibraryFiles: File[] = []
  const sourceMaterialFiles: File[] = []
  files.forEach((file) => {
    if (destinationForFile(file) === 'mediaLibrary') {
      mediaLibraryFiles.push(file)
    } else {
      sourceMaterialFiles.push(file)
    }
  })
  return { mediaLibraryFiles, sourceMaterialFiles }
}
